import { Modal } from "flowbite-react"
import { CheckCircle, Gift, Phone, Xmark } from "iconoir-react"

export default function ReferralRewardModal({
  show,
  setShow,
  onContinue,
  onClose
}: {
  show: boolean
  setShow: (show: boolean) => void
  onContinue: () => void
  onClose: () => void
}) {
  const handleContinue = () => {
    setShow(false)
    onContinue()
  }

  const handleClose = () => {
    setShow(false)
    onClose()
  }

  return (
    <Modal show={show} onClose={handleClose} popup size="lg" className="pt-safe">
      <div className="relative p-6 text-center bg-gradient-to-br from-purple-600 to-indigo-700 rounded-lg">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 rounded-full text-purple-200 hover:text-white hover:bg-white/10 transition-colors"
          aria-label="Close"
        >
          <Xmark className="w-5 h-5" />
        </button>

        <div className="mb-6">
          <div className="w-20 h-20 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
            <Gift className="w-10 h-10 text-white" strokeWidth={2} />
          </div>
          <h2 className="text-3xl font-bold text-white mb-3">You Got Referred! 🎉</h2>
          <p className="text-lg text-purple-100 mb-6 px-2">
            Help us thank your friend by quickly verifying your phone number.
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-6">
          <h3 className="text-white font-semibold mb-4 flex items-center justify-center gap-2">
            <Gift className="w-5 h-5" />
            Here's what happens:
          </h3>
          <div className="space-y-3 text-purple-100 text-sm">
            <div className="flex items-center justify-start gap-3 text-left">
              <CheckCircle className="w-5 h-5 text-green-300 flex-shrink-0" />
              <span>
                You already got <strong className="text-white">60 free minutes</strong> when you signed up
              </span>
            </div>
            <div className="flex items-center justify-start gap-3 text-left">
              <CheckCircle className="w-5 h-5 text-green-300 flex-shrink-0" />
              <span>
                Your friend gets <strong className="text-white">60 minutes</strong> after you verify
              </span>
            </div>
            <div className="flex items-center justify-start gap-3 text-left">
              <CheckCircle className="w-5 h-5 text-green-300 flex-shrink-0" />
              <span>Everyone wins! 🚀</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-purple-200 text-sm mb-6">
          <Phone className="w-4 h-4" />
          <span>Takes under 2 minutes • US numbers only</span>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={handleContinue}
            className="w-full py-4 bg-white text-purple-600 font-bold text-lg rounded-full hover:bg-purple-50 transition-all duration-200 transform hover:scale-105 shadow-lg"
          >
            Verify Phone & Help Friend
          </button>
          <button
            onClick={handleClose}
            className="w-full py-3 text-purple-200 font-medium rounded-full hover:bg-white/10 transition-colors"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </Modal>
  )
}
